import * as XLSX from 'xlsx';
import i18n from '../i18n/config';

const MACHINE_HEADERS = ['display_number', 'physical_id', 'pool_key', 'is_active'] as const;

/** Excel テンプレート（.xlsx）— 1 行目は UI 言語の表示見出し、2 行目は機械名（パーサ互換） */
export function downloadTppCardExcelTemplate(poolKey = 'default') {
  const t = i18n.t.bind(i18n);
  const displayHeaders = [
    t('tpp.import_header_display_number'),
    t('tpp.import_header_physical_id'),
    t('tpp.import_header_pool_key'),
    t('tpp.import_header_is_active'),
  ];
  const sheet = XLSX.utils.aoa_to_sheet([
    displayHeaders,
    [...MACHINE_HEADERS],
    [41, 'PB302108021024659', poolKey, true],
    [42, 'PB302108021024660', poolKey, true],
  ]);
  sheet['!cols'] = [{ wch: 16 }, { wch: 22 }, { wch: 12 }, { wch: 10 }];
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, 'cards');
  XLSX.writeFile(workbook, 'tpp_cards_import_template.xlsx');
}
